<template>
  <div class="photo-selector" :data-testid="tid">
    <div class="photo-selector__widget">
      <ViewMode
        v-if="hasMediaObject"
        :mediaObject="mediaObject"
        :canRemoveImage="canRemoveImage"
        @removeImage="handleRemoveImage"
      />
      <EditMode
        v-if="canUploadImage"
        :isPublic="isPublic"
        :tourId="tourId"
        @imageUploaded="handleImageUploaded"
      />
    </div>
    <p
      v-if="canUploadImage"
      class="mb-0 photo-selector__formats-label grey--text text--darken-1"
    >
      {{ $t('common.valid_file_formats') }}
    </p>
  </div>
</template>

<script>
import mixin from '@/mixins/mixin'
import EditMode from './EditMode'
import ViewMode from './ViewMode'

export default {
  name: 'ThumbnailPhotoSelector',

  mixins: [mixin],

  props: {
    isPublic: {
      type: Boolean,
      default: false,
      required: false,
    },
    mediaObject: {
      type: Object,
      required: false,
      default: () => {
        return {}
      },
    },
    isEditMode: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    tid: {
      type: String,
      default: 'photo-selector',
    },
    showEditor: {
      type: Boolean,
      required: false,
      default: true,
    },
    tourId: {
      type: String,
      required: false,
    },
  },

  components: {
    EditMode,
    ViewMode,
  },

  methods: {
    handleImageUploaded(data) {
      this.$emit('onDoneUploading', data)
    },

    handleRemoveImage() {
      this.$emit('onRemovePhoto')
    },
  },

  computed: {
    hasMediaObject() {
      return Boolean(this.mediaObject?.id)
    },

    canRemoveImage() {
      return this.hasMediaObject && this.isEditMode && !this.disabled
    },

    canUploadImage() {
      return !this.hasMediaObject && this.isEditMode && !this.disabled
    },
  },
}
</script>

<style lang="scss" scoped>
.photo-selector {
  &__widget {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100px;
    height: 100px;
    background: $color-blue-grey-lighten3;
    border-radius: 4px;
  }

  &__formats-label {
    font-size: 10px;
    line-height: 16px;
    margin-top: 8px;
  }
}
</style>
